import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SelectedInsrReports } from '../../../model/InsuranceAcquisitionDetails';
import { DashboardService } from '../../../services/dashboard.service';

@Component({
  standalone: false,
  selector: 'app-acquisitions-insurance-update',
  templateUrl: './acquisitions-update-insurance.component.html',
  styleUrls: ['./acquisitions-update-insurance.component.css'],
  providers: [DashboardService]
})
export class AcquisitionsInsuranceUpdateComponent implements OnInit {
  // @ViewChild('dialog1', { read: ElementRef }) dialogRef: ElementRef;

  @Input() scrWidth: number;
  @Input() scrHeight: number;
  @Input() showAcqnUpdateInsuranceComponent: boolean;
  @Input() isLoading: boolean = false;
  @Input() set selectedReportArrayDisplayValue(value: SelectedInsrReports[]) {
    this.selectedReportArrayDisplay = value;

    console.log("selectedReportArrayDisplay : ", this.selectedReportArrayDisplay);

    this.selectedReportArrayDisplay.forEach(value => {
      if (value.insr === null || value.insr === undefined || value.insr === "") {
        value.insr = "N";
      }
      if (value.propAccord25Typ === null || value.propAccord25Typ === undefined || value.propAccord25Typ === "") {
        value.propAccord25Typ = "N";
      }
      if (value.propAccord28Typ === null || value.propAccord28Typ === undefined || value.propAccord28Typ === "") {
        value.propAccord28Typ = "N";
      }
      if (value.propAmrcnLandTtlAsscTyp === null || value.propAmrcnLandTtlAsscTyp === undefined || value.propAmrcnLandTtlAsscTyp === "") {
        value.propAmrcnLandTtlAsscTyp = "N";
      }
      if (value.propFldAnlysWkshTyp === null || value.propFldAnlysWkshTyp === undefined || value.propFldAnlysWkshTyp === "") {
        value.propFldAnlysWkshTyp = "N";
      }
      if (value.propNfipTyp === null || value.propNfipTyp === undefined || value.propNfipTyp === "") {
        value.propNfipTyp = "N";
      }
      if (value.propPrvtOrExcsFldInsrCvrgTyp === null || value.propPrvtOrExcsFldInsrCvrgTyp === undefined || value.propPrvtOrExcsFldInsrCvrgTyp === "") {
        value.propPrvtOrExcsFldInsrCvrgTyp = "N";
      }
      if (value.propSpclFldHzrdDtmnFormTyp === null || value.propSpclFldHzrdDtmnFormTyp === undefined || value.propSpclFldHzrdDtmnFormTyp === "") {
        value.propSpclFldHzrdDtmnFormTyp = "N";
      }
      if (value.propSchOfValTyp === null || value.propSchOfValTyp === undefined || value.propSchOfValTyp === "") {
        value.propSchOfValTyp = "N";
      }
      if (value.propInsrTyp === null || value.propInsrTyp === undefined || value.propInsrTyp === "") {
        value.propInsrTyp = "N";
      }
      if (value.propLiabPlcyTyp === null || value.propLiabPlcyTyp === undefined || value.propLiabPlcyTyp === "") {
        value.propLiabPlcyTyp = "N";
      }
    });
  };
  @Output() finishAndClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

  originalSelectedReportArrayDisplay: any = [];
  selectedReportArrayDisplay: SelectedInsrReports[] = [];
  columnHeaders: any[];
  errorMessageSelection: string = "";
  errorMessageAPI: string = "";
  showSpinner: boolean = false;

  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.columnHeaders = [
      { field: 'propNme', header: 'Property Name' },
      { field: 'insr', header: 'INSR', width: '6%', toggleFlag: 'insrFlag', isModified: 'isInsrMod' },
      { field: 'propAccord28Typ', header: 'A28', width: '6%', toggleFlag: 'propAccord28TypFlag', isModified: 'isPropAccord28TypFlagMod' },
      { field: 'propAmrcnLandTtlAsscTyp', header: 'ALTA', width: '6%', toggleFlag: 'propAmrcnLandTtlAsscTypFlag', isModified: 'isPropAmrcnLandTtlAsscTypFlagMod' },
      { field: 'propFldAnlysWkshTyp', header: 'FAW', width: '6%', toggleFlag: 'propFldAnlysWkshTypFlag', isModified: 'isPropFldAnlysWkshTypFlagMod' },
      { field: 'propNfipTyp', header: 'NFIP', width: '6%', toggleFlag: 'propNfipTypFlag', isModified: 'isPropNfipTypFlagMod' },
      { field: 'propPrvtOrExcsFldInsrCvrgTyp', header: 'PFX', width: '6%', toggleFlag: 'propPrvtOrExcsFldInsrCvrgTypFlag', isModified: 'isPropPrvtOrExcsFldInsrCvrgTypFlagMod' },
      { field: 'propSpclFldHzrdDtmnFormTyp', header: 'SFHDF', width: '6%', toggleFlag: 'propSpclFldHzrdDtmnFormTypFlag', isModified: 'isPropSpclFldHzrdDtmnFormTypFlagMod' },
      { field: 'propSchOfValTyp', header: 'SOV', width: '6%', toggleFlag: 'propSchOfValTypFlag', isModified: 'isPropSchOfValTypFlagMod' },
      { field: 'propAccord25Typ', header: 'A25', width: '6%', toggleFlag: 'propAccord25TypFlag', isModified: 'isPropAccord25TypFlagMod' },
      { field: 'propInsrTyp', header: 'PROP', width: '6%', toggleFlag: 'propInsrTypFlag', isModified: 'isPropInsrTypFlagMod' },
      { field: 'propLiabPlcyTyp', header: 'LIA', width: '6%', toggleFlag: 'propLiabPlcyTypFlag', isModified: 'isPropLiabPlcyTypFlagMod' }
    ];

    console.log('selectedReportArrayDisplay:', this.selectedReportArrayDisplay);

    // Loop through selectedReportArrayDisplay and set boolean column for toggle component
    this.addBooleanFlags();

    // Save the flags for comparision
    this.saveOriginalSelectedReportArrayDisplay();
  }

  addBooleanFlags() {
    for (let i = 0; i < this.selectedReportArrayDisplay.length; i++) {
      // INSR flag
      if (this.selectedReportArrayDisplay[i].insr == 'N') {
        this.selectedReportArrayDisplay[i].insrFlag = false;
      } else if (this.selectedReportArrayDisplay[i].insr == 'N/A') {
        this.selectedReportArrayDisplay[i].insrFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].insrFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isInsrMod = false;

      // Accord 25 flag
      if (this.selectedReportArrayDisplay[i].propAccord25Typ == 'N') {
        this.selectedReportArrayDisplay[i].propAccord25TypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propAccord25Typ == 'N/A') {
        this.selectedReportArrayDisplay[i].propAccord25TypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propAccord25TypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropAccord25TypFlagMod = false;

      // Accord 28 flag
      if (this.selectedReportArrayDisplay[i].propAccord28Typ == 'N') {
        this.selectedReportArrayDisplay[i].propAccord28TypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propAccord28Typ == 'N/A') {
        this.selectedReportArrayDisplay[i].propAccord28TypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propAccord28TypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropAccord28TypFlagMod = false;

      // American Land Title Association flag
      if (this.selectedReportArrayDisplay[i].propAmrcnLandTtlAsscTyp == 'N') {
        this.selectedReportArrayDisplay[i].propAmrcnLandTtlAsscTypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propAmrcnLandTtlAsscTyp == 'N/A') {
        this.selectedReportArrayDisplay[i].propAmrcnLandTtlAsscTypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propAmrcnLandTtlAsscTypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropAmrcnLandTtlAsscTypFlagMod = false;

      // Flood Analysis Worksheet flag
      if (this.selectedReportArrayDisplay[i].propFldAnlysWkshTyp == 'N') {
        this.selectedReportArrayDisplay[i].propFldAnlysWkshTypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propFldAnlysWkshTyp == 'N/A') {
        this.selectedReportArrayDisplay[i].propFldAnlysWkshTypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propFldAnlysWkshTypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropFldAnlysWkshTypFlagMod = false;

      // NFIP flag
      if (this.selectedReportArrayDisplay[i].propNfipTyp == 'N') {
        this.selectedReportArrayDisplay[i].propNfipTypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propNfipTyp == 'N/A') {
        this.selectedReportArrayDisplay[i].propNfipTypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propNfipTypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropNfipTypFlagMod = false;

      // Private or Excess Flood Insurance Coverage flag
      if (this.selectedReportArrayDisplay[i].propPrvtOrExcsFldInsrCvrgTyp == 'N') {
        this.selectedReportArrayDisplay[i].propPrvtOrExcsFldInsrCvrgTypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propPrvtOrExcsFldInsrCvrgTyp == 'N/A') {
        this.selectedReportArrayDisplay[i].propPrvtOrExcsFldInsrCvrgTypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propPrvtOrExcsFldInsrCvrgTypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropPrvtOrExcsFldInsrCvrgTypFlagMod = false;

      // Special Flood Hazard Determination Form flag
      if (this.selectedReportArrayDisplay[i].propSpclFldHzrdDtmnFormTyp == 'N') {
        this.selectedReportArrayDisplay[i].propSpclFldHzrdDtmnFormTypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propSpclFldHzrdDtmnFormTyp == 'N/A') {
        this.selectedReportArrayDisplay[i].propSpclFldHzrdDtmnFormTypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propSpclFldHzrdDtmnFormTypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropSpclFldHzrdDtmnFormTypFlagMod = false;

      // Schedule of Values flag
      if (this.selectedReportArrayDisplay[i].propSchOfValTyp == 'N') {
        this.selectedReportArrayDisplay[i].propSchOfValTypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propSchOfValTyp == 'N/A') {
        this.selectedReportArrayDisplay[i].propSchOfValTypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propSchOfValTypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropSchOfValTypFlagMod = false;

      // Property Insurance Type flag
      if (this.selectedReportArrayDisplay[i].propInsrTyp == 'N') {
        this.selectedReportArrayDisplay[i].propInsrTypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propInsrTyp == 'N/A') {
        this.selectedReportArrayDisplay[i].propInsrTypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propInsrTypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropInsrTypFlagMod = false;

      // Liability Policy flag
      if (this.selectedReportArrayDisplay[i].propLiabPlcyTyp == 'N') {
        this.selectedReportArrayDisplay[i].propLiabPlcyTypFlag = false;
      } else if (this.selectedReportArrayDisplay[i].propLiabPlcyTyp == 'N/A') {
        this.selectedReportArrayDisplay[i].propLiabPlcyTypFlag = true;
      } else {
        this.selectedReportArrayDisplay[i].propLiabPlcyTypFlag = false; // Default for 'Y' or other values
      }
      this.selectedReportArrayDisplay[i].isPropLiabPlcyTypFlagMod = false;
    }
  }

  saveOriginalSelectedReportArrayDisplay() {
    for (let i = 0; i < this.selectedReportArrayDisplay.length; i++) {
      let rowData = {
        id: this.selectedReportArrayDisplay[i].id,
        insr: this.selectedReportArrayDisplay[i].insr,
        propAccord25Typ: this.selectedReportArrayDisplay[i].propAccord25Typ,
        propAccord28Typ: this.selectedReportArrayDisplay[i].propAccord28Typ,
        propAmrcnLandTtlAsscTyp: this.selectedReportArrayDisplay[i].propAmrcnLandTtlAsscTyp,
        propFldAnlysWkshTyp: this.selectedReportArrayDisplay[i].propFldAnlysWkshTyp,
        propNfipTyp: this.selectedReportArrayDisplay[i].propNfipTyp,
        propPrvtOrExcsFldInsrCvrgTyp: this.selectedReportArrayDisplay[i].propPrvtOrExcsFldInsrCvrgTyp,
        propSpclFldHzrdDtmnFormTyp: this.selectedReportArrayDisplay[i].propSpclFldHzrdDtmnFormTyp,
        propSchOfValTyp: this.selectedReportArrayDisplay[i].propSchOfValTyp,
        propInsrTyp: this.selectedReportArrayDisplay[i].propInsrTyp,
        propLiabPlcyTyp: this.selectedReportArrayDisplay[i].propLiabPlcyTyp
      }
      this.originalSelectedReportArrayDisplay.push(rowData);
    }
  }

  getAcquisitionDashboardCounts() { }

  setErrorMessageSelection(errMsg) {
    this.errorMessageSelection = errMsg;
  }

  setErrorMessageAPI(errMsg) {
    this.errorMessageAPI = errMsg;
  }

  onCancelled() {
    for (let i = 0; i < this.selectedReportArrayDisplay.length; i++) {
      this.selectedReportArrayDisplay[i].insr = this.originalSelectedReportArrayDisplay[i].insr;
      this.selectedReportArrayDisplay[i].propAccord25Typ = this.originalSelectedReportArrayDisplay[i].propAccord25Typ;
      this.selectedReportArrayDisplay[i].propAccord28Typ = this.originalSelectedReportArrayDisplay[i].propAccord28Typ;
      this.selectedReportArrayDisplay[i].propAmrcnLandTtlAsscTyp = this.originalSelectedReportArrayDisplay[i].propAmrcnLandTtlAsscTyp;
      this.selectedReportArrayDisplay[i].propFldAnlysWkshTyp = this.originalSelectedReportArrayDisplay[i].propFldAnlysWkshTyp;
      this.selectedReportArrayDisplay[i].propNfipTyp = this.originalSelectedReportArrayDisplay[i].propNfipTyp;
      this.selectedReportArrayDisplay[i].propPrvtOrExcsFldInsrCvrgTyp = this.originalSelectedReportArrayDisplay[i].propPrvtOrExcsFldInsrCvrgTyp;
      this.selectedReportArrayDisplay[i].propSpclFldHzrdDtmnFormTyp = this.originalSelectedReportArrayDisplay[i].propSpclFldHzrdDtmnFormTyp;
      this.selectedReportArrayDisplay[i].propSchOfValTyp = this.originalSelectedReportArrayDisplay[i].propSchOfValTyp;
      this.selectedReportArrayDisplay[i].propInsrTyp = this.originalSelectedReportArrayDisplay[i].propInsrTyp;
      this.selectedReportArrayDisplay[i].propLiabPlcyTyp = this.originalSelectedReportArrayDisplay[i].propLiabPlcyTyp;
    }
    this.finishAndClosed.emit(false);
  }

  onFinishAndClosed() {
    this.setErrorMessageSelection("");

    // Determine if anything changed
    let changedReportArrayDisplay: SelectedInsrReports[] = this.getChangedRows();
    if (changedReportArrayDisplay.length == 0) {
      this.setErrorMessageSelection("No change detected.");
      return;
    }

    // Call the service to update flags
    this.showSpinner = true;
    this.dashboardService.setAcquisitionInsuranceReportFlags(changedReportArrayDisplay).subscribe(
      res => {
        this.showSpinner = false;

        //Everything is good, close the dialog
        this.finishAndClosed.emit(true);
      },
      error => {
        this.showSpinner = false;
        this.setErrorMessageAPI("We're sorry, something went wrong on our end. Please try again later or contact our support team.");
      }
    )
  }

  getChangedRows() {
    let changedReportArrayDisplay: SelectedInsrReports[] = [];
    console.log('getChangedRows - Starting comparison...');
    
    for (let i = 0; i < this.selectedReportArrayDisplay.length; i++) {
      const current = this.selectedReportArrayDisplay[i];
      const original = this.originalSelectedReportArrayDisplay[i];
      
      let hasChanges = false;
      let changedFields = [];

      if (original.insr != current.insr) {
        hasChanges = true;
        changedFields.push('insr: ' + original.insr + ' -> ' + current.insr);
      }
      if (original.propAccord25Typ != current.propAccord25Typ) {
        hasChanges = true;
        changedFields.push('propAccord25Typ: ' + original.propAccord25Typ + ' -> ' + current.propAccord25Typ);
      }
      if (original.propAccord28Typ != current.propAccord28Typ) {
        hasChanges = true;
        changedFields.push('propAccord28Typ: ' + original.propAccord28Typ + ' -> ' + current.propAccord28Typ);
      }
      if (original.propAmrcnLandTtlAsscTyp != current.propAmrcnLandTtlAsscTyp) {
        hasChanges = true;
        changedFields.push('propAmrcnLandTtlAsscTyp: ' + original.propAmrcnLandTtlAsscTyp + ' -> ' + current.propAmrcnLandTtlAsscTyp);
      }
      if (original.propFldAnlysWkshTyp != current.propFldAnlysWkshTyp) {
        hasChanges = true;
        changedFields.push('propFldAnlysWkshTyp: ' + original.propFldAnlysWkshTyp + ' -> ' + current.propFldAnlysWkshTyp);
      }
      if (original.propNfipTyp != current.propNfipTyp) {
        hasChanges = true;
        changedFields.push('propNfipTyp: ' + original.propNfipTyp + ' -> ' + current.propNfipTyp);
      }
      if (original.propPrvtOrExcsFldInsrCvrgTyp != current.propPrvtOrExcsFldInsrCvrgTyp) {
        hasChanges = true;
        changedFields.push('propPrvtOrExcsFldInsrCvrgTyp: ' + original.propPrvtOrExcsFldInsrCvrgTyp + ' -> ' + current.propPrvtOrExcsFldInsrCvrgTyp);
      }
      if (original.propSpclFldHzrdDtmnFormTyp != current.propSpclFldHzrdDtmnFormTyp) {
        hasChanges = true;
        changedFields.push('propSpclFldHzrdDtmnFormTyp: ' + original.propSpclFldHzrdDtmnFormTyp + ' -> ' + current.propSpclFldHzrdDtmnFormTyp);
      }
      if (original.propSchOfValTyp != current.propSchOfValTyp) {
        hasChanges = true;
        changedFields.push('propSchOfValTyp: ' + original.propSchOfValTyp + ' -> ' + current.propSchOfValTyp);
      }
      if (original.propInsrTyp != current.propInsrTyp) {
        hasChanges = true;
        changedFields.push('propInsrTyp: ' + original.propInsrTyp + ' -> ' + current.propInsrTyp);
      }
      if (original.propLiabPlcyTyp != current.propLiabPlcyTyp) {
        hasChanges = true;
        changedFields.push('propLiabPlcyTyp: ' + original.propLiabPlcyTyp + ' -> ' + current.propLiabPlcyTyp);
      }

      if (hasChanges) {
        console.log('Row ' + i + ' has changes:', changedFields);
        changedReportArrayDisplay.push(current);
      }
    }
    
    console.log('getChangedRows - Total changed rows:', changedReportArrayDisplay.length);
    return changedReportArrayDisplay;
  }

  onChangeFlagValue(event, row, field, isModified) {
    this.setErrorMessageSelection("");
    this.setErrorMessageAPI("");

    console.log('onChangeFlagValue - Before:', { field, value: row[field], checked: event.checked, rowId: row['id'] });

    if (event.checked) {
      row[field] = 'N/A';
    } else {
      row[field] = 'N';
    }

    console.log('onChangeFlagValue - After:', { field, value: row[field] });

    let finding = this.findInArrayWhereID(this.originalSelectedReportArrayDisplay, row['id']);

    if (finding && finding.length > 0) {
      console.log('onChangeFlagValue - Original:', { field, originalValue: finding[0][field] });
      row[isModified] = !(row[field] == finding[0][field]);
      console.log('onChangeFlagValue - isModified:', row[isModified]);
    } else {
      console.error('onChangeFlagValue - Original value not found for id:', row['id']);
      row[isModified] = true; // Assume modified if original not found
    }
  }

  findInArrayWhereID(arr, id) {
    return arr.filter((obj) => {
      return (obj.id == id)
    })
  }
}


